var installedModules = {};
var moduleToHandlerMapping = {
	0: {
		getter: () => (() => (__webpack_require__(1371))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	18: {
		getter: () => (() => (__webpack_require__(1380))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	3538: {
		getter: () => (() => (__webpack_require__(1057))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	3831: {
		getter: () => (() => (__webpack_require__(2593))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	4017: {
		getter: () => (() => (__webpack_require__(2576))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.20.40",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "glamor",
	},
	4020: {
		getter: () => (() => (__webpack_require__(2591))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "8.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	4033: {
		getter: () => (() => (__webpack_require__(2577))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	4244: {
		getter: () => (() => (__webpack_require__(2592))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^6.30.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-router-dom",
	},
	4371: {
		getter: () => (() => (__webpack_require__(2578))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "npm:react-dnd@^11.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dnd-latest",
	}
};
var initialConsumes = [0,18];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"2": [
		0,
		18
	],
	"3": [
		3538,
		3831,
		4017,
		4020,
		4033,
		4244,
		4371
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}